import { Component } from '@angular/core';
import { LoadingService } from '../../../services/loading-service/loading-service.service';


@Component({
    selector: 'app-spinner',
    templateUrl: './spinner-component.html',
    styleUrls: ['./spinner-component.scss'],
    standalone: false
})
export class SpinnerComponent {

  spinCount: number = 0

  constructor(
    public loading: LoadingService
  ) {
    this.loading.status$.subscribe(data => {
      this.spinCount = data
    })

  }

}
